import { Link } from 'react-router-dom';
import { useProfileCompletion } from '../../hooks/useProfileCompletion';
import { useAuth } from '../../contexts/AuthContext';
import './ProfileIncompleteBanner.css';

const ProfileIncompleteBanner = () => {
  const { user } = useAuth();
  const { isProfileComplete, completionPercentage, completedCount, totalRequired } = useProfileCompletion(user);

  if (isProfileComplete || !user) return null;

  return (
    <div className="profile-incomplete-banner">
      <div className="banner-content">
        <div className="banner-icon">⚠️</div>
        <div className="banner-text">
          <h4>Complete Your Profile</h4>
          <p>You've completed {completedCount} of {totalRequired} required fields. Please complete your profile to continue.</p>
          <div className="progress-bar">
            <div className="progress-fill" style={{ width: `${completionPercentage}%` }}></div>
          </div>
        </div>
        <Link to="/account/complete" className="banner-button">
          Complete Now
        </Link>
        <button className="banner-close" onClick={() => document.querySelector('.profile-incomplete-banner')?.remove()}>×</button>
      </div>
    </div>
  );
};

export default ProfileIncompleteBanner;
